interface IconProps {
  size?: number;
  color?: string;
}

/**
 *
 * @param size - 아이콘 크기
 * @param color - 아이콘 색상
 */
const ChevronRight: React.FC<IconProps> = ({ size = 18, color = "#191919" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill="none">
    <path d="M6 13.1667L10.6667 8.50001L6 3.83334" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default ChevronRight;
